import "./CompanyDepartments.css";
import { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import AddIcon from "@mui/icons-material/Add";
import { PiPencilSimpleLineBold } from "react-icons/pi";
import { MdOutlineAssignmentTurnedIn } from "react-icons/md";
import { PiUserCheck } from "react-icons/pi";
import { RiDeleteBinLine } from "react-icons/ri";
import Modal from "react-bootstrap/Modal";
import { AgGridReact } from "ag-grid-react";
import CustomPagination from "../../../components/CustomPagination";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "react-bootstrap/Button";
import { ToastContainer, toast } from "react-toastify";
import { Form, Row, Col } from "react-bootstrap";
import AssignEmployee from "../../../components/AssignEmployee";
import { useDispatch, useSelector } from "react-redux";
import {
  createDepartment,
  fetchDepartmentData,
  initDepartState,
} from "../../../redux/slices/departmentSlice";
import {
  fetchBranchData,
  initBranchState,
} from "../../../redux/slices/branchSlice";
import {
  commonSaveData,
  commonGetDataFourth,
  initCommonState,
} from "../../../redux/slices/commonSlice";
import ButtonCom from "../../../components/button/button";
import {
  updateDepartmentPath,
  deleteDepartmentPath,
  getStaffEmployeeDepartmentPath,
  assignEmployeeDepartmentPath,
} from "../../../services/config";
import Widgets from "../../../components/Widgets";
import WidgetsIcon from "../../../components/Widgets/icon";
import { HasPermission } from "../../../services/hasPermission";
import { useGlobalToast } from "../../../stopOldToastGlobally";

const paginationPageSize = 10;
const paginationPageSizeSelector = [10, 20, 50, 100];

const CompanyDepartments = () => {
  const user = localStorage.getItem("user_data")
    ? JSON.parse(localStorage.getItem("user_data"))
    : null;
  const dispatch = useDispatch();
  const departmentStore = useSelector((state) => state.department);
  const branchStore = useSelector((state) => state.branch);
  const commonState = useSelector((state) => state.common);
  const toast = useGlobalToast(); 

  const [currentPage, setCurrentPage] = useState(1);
  const [open, setOpen] = useState(false);
  const [validated, setValidated] = useState(false);

  const [departmentList, setDepartmentList] = useState([]);
  const [branchList, setBranchList] = useState([]);

  const [addDepartment, setAddDepartment] = useState({
    userId: user.user_id,
    staffId: null,
    departmentId: "",
    departmentName: "",
  });

  const [outletName, setOutletName] = useState("");
  const [departmentId, setDepartmentId] = useState("");
  const [employeeList, setEmployeeList] = useState([]);
  const [filterEmployeeList, setFilterEmployeeList] = useState([]);
  const [selectIs, setSelectIs] = useState(true);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [selectedUsersList, setSelectedUsersList] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [show1, setShow1] = useState(false);
  const isSelectAll =
    selectedUsers.length === employeeList.length && employeeList.length > 0;

  const [state, setState] = useState({
    branchId: "",
    departmentId: "",
  });

  const [gridApi, setGridApi] = useState(null);

  const onGridReady = (params) => {
    setGridApi(params.api);
  };

  const getDepartment = useCallback((data) => {
    dispatch(fetchDepartmentData(user.user_id));
    dispatch(fetchBranchData());
  });

  useEffect(() => {
    getDepartment();
  }, []);

  const [show, setShow] = useState(false);

  const handleModalClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [isEdit, setIsEdit] = useState(false);
  const handleEdit = (row) => {
    setIsEdit(true);
    setAddDepartment({
      ...addDepartment,
      staffId: row.staff_id,
      departmentName: row.department_name,
      departmentId: row.departmentId,
    });
    handleClickOpen();
  };
  const handleEditSubmit = (e) => {
    e.preventDefault();
    let d = {
      path: updateDepartmentPath,
      data: addDepartment,
    };
    dispatch(commonSaveData(d));
  };

  const [delId, setDelId] = useState(null);
  const handleDelete = (row) => {
    setDelId(row.departmentId);
    handleShow();
  };
  const handleDeleteSubmit = () => {
    let d = {
      path: deleteDepartmentPath,
      data: {
        userId: user.user_id,
        departmentId: delId,
      },
    };
    dispatch(commonSaveData(d));
    handleModalClose();
  };

  useEffect(() => {
    if (commonState.commonSuccess) {
      toast.success(commonState.commonMessage);
      setOpen(false);
      getDepartment();
      setIsEdit(false);
      setDelId(null);
      setAddDepartment({
        ...addDepartment,
        staffId: null,
        departmentName: "",
        departmentId: "",
      });
      handleModalClose1();
      dispatch(initCommonState());
    }
    if (commonState.commonError) {
      toast.success(commonState.commonMessage);
      setOpen(false);
      getDepartment();
      setIsEdit(false);
      setDelId(null);
      setAddDepartment({
        ...addDepartment,
        staffId: null,
        departmentName: "",
        departmentId: "",
      });
      dispatch(initCommonState());
    }
  }, [commonState, dispatch]);

 const heading = [
  {
    headerName: "S.No",
    field: "sno",
    width: 80,
    sortable: false,
    filter: false,
    suppressMovable: true,
    cellStyle: { 
      textAlign: "center",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontWeight: "500",
      padding: "0px",
      margin: "0px",
    },
    headerClass: "text-center",
    valueGetter: (params) => {
      if (!params || !params.node) return '';
      
      const api = params.api;
      const rowIndex = params.node.rowIndex;
      
      if (!api) return rowIndex + 1;
      
      try {
        const paginationEnabled = api.isPaginationActive();
        if (paginationEnabled) {
          const currentPage = api.paginationGetCurrentPage();
          const pageSize = api.paginationGetPageSize();
          return (currentPage * pageSize) + rowIndex + 1;
        }
        return rowIndex + 1;
      } catch (error) {
        return rowIndex + 1;
      }
    },
    comparator: (valueA, valueB, nodeA, nodeB) => {
      const indexA = nodeA?.rowIndex ?? 0;
      const indexB = nodeB?.rowIndex ?? 0;
      return indexA - indexB;
    }
  },
  {
    headerName: "Department Name",
    field: "department_name",
    flex: 1,
    minWidth: 150,
    cellStyle: { 
      textAlign: "left",
      display: "flex",
      alignItems: "center",
      paddingLeft: "15px",
    },
    headerClass: "text-left",
  },
  {
    headerName: "Status",
    field: "status",
    width: 120,
    cellStyle: { 
      textAlign: "center",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    headerClass: "text-center",
    cellRenderer: (rowData) => {
      return rowData.data.status == 1 ? "Active" : "InActive";
    },
  },
  {
    headerName: "Action",
    width: 180,
    cellStyle: { 
      textAlign: "center",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      padding: "0px",
    },
    headerClass: "text-center",
    cellRenderer: (rowData) => {
      return (
        <div 
          style={{ 
            display: "flex", 
            alignItems: "center", 
            justifyContent: "center",
            gap: "12px",
            width: "100%",
            height: "100%",
            padding: "0px",
            margin: "0px",
          }}
        >
          {HasPermission("Departments", "create") && (
            <PiUserCheck
              style={{
                cursor: "pointer",
                fontSize: "24px",
                color: "green",
                margin: "0px",
                padding: "0px",
              }}
              className="assign-icon"
              onClick={() => {
                handleAssignId(rowData.data);
              }}
            />
          )}

          {HasPermission("Departments", "edit") && (
            <PiPencilSimpleLineBold
              style={{ 
                cursor: "pointer", 
                fontSize: "24px",
                color: "#666",
                margin: "0px",
                padding: "0px",
              }}
              className="edit-icon"
              onClick={() => {
                handleEdit(rowData.data);
              }}
            />
          )}

          {HasPermission("Departments", "delete") && (
            <RiDeleteBinLine 
              className="delete-icon"
              style={{ 
                cursor: "pointer", 
                fontSize: "24px", 
                color: "red",
                margin: "0px",
                padding: "0px",
              }}
              onClick={() => handleDelete(rowData.data)}
            />
          )}

          {!HasPermission("Departments", "approve") &&
            !HasPermission("Departments", "edit") &&
            !HasPermission("Departments", "delete") &&
            <span style={{ margin: "0px", padding: "0px" }}>-</span>}
        </div>
      );
    },
  },
];

  useEffect(() => {
    if (departmentStore.depGetSuccess) {
      setDepartmentList(departmentStore.depGetData);
      dispatch(initDepartState());
    }
    if (departmentStore.depGetError) {
    }
    if (branchStore.brnGetSuccess) {
      setBranchList(branchStore.brnGetData);
      dispatch(initBranchState());
    }
  }, [dispatch, departmentStore, branchStore]);

  useEffect(() => {
    if (departmentStore.depSuccess) {
      setDepartmentList(departmentStore.depGetData);
      getDepartment();
    }
    if (departmentStore.depError) {
    }
  }, [departmentStore]);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setValidated(false);
    setOpen(false);
    setIsEdit(false);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setAddDepartment((pv) => ({ ...pv, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const form = e.currentTarget;
    e.stopPropagation();
    if (form.checkValidity() === false) {
      setValidated(true);
    } else {
      dispatch(createDepartment(addDepartment));
      setAddDepartment({
        ...addDepartment,
        departmentName: "",
      });
    }
  };

  useEffect(() => {
    if (departmentStore.depSuccess) {
      getDepartment();
      toast.success(departmentStore.depMessage);
      dispatch(initDepartState());
      handleClose();
    }
    if (departmentStore.depError) {
      toast.error(departmentStore.depMessage);
      dispatch(initDepartState());
      handleClose();
    }
  }, [dispatch, departmentStore]);

  

  const handleModalClose1 = () => {
    setShow1(false);
    setSelectedUsers([]);
    setSelectedUsersList([]);
    setState((pre) => ({
      ...pre,
      branchId: "",
      departmentId: "",
    }));
    setSearchQuery("")
  };

  const handleAssignId = (data) => {
    setOutletName(data.department_name);
    setDepartmentId(data.departmentId);
    // getEmployeeList(data.departmentId);
    setTimeout(() => {
      handleShow1();
    }, 500);
  };

  const handleShow1 = () => setShow1(true);

  // const getEmployeeList = useCallback((id) => {
  //   const path = getStaffEmployeeDepartmentPath(user.user_id, id);
  //   dispatch(commonGetDataFourth(path));
  // }, []);

  useEffect(() => {
    const path = getStaffEmployeeDepartmentPath(user.user_id, departmentId, state.branchId);
    dispatch(commonGetDataFourth(path));
  }, [user.user_id, departmentId, state.branchId])

  useEffect(() => {
    if (commonState.commonGetFourthSuccess) {
      if (searchQuery != "") {
        searchEmployees(searchQuery, commonState.commonGetFourthData)
      } else {
        setEmployeeList(commonState.commonGetFourthData);
        setFilterEmployeeList(commonState.commonGetFourthData);
        const initiallySelected = commonState.commonGetFourthData
          .filter((row) => row.departmentAssignedStatus === "1")
          .map((row) => row.staffId);

        setSelectedUsers(initiallySelected);

        const initiallySelectedUsers = commonState.commonGetFourthData
          .filter((row) => row.departmentAssignedStatus === "1") // Check API ka "selected: true"
          .map((row) => row);
        setSelectedUsersList(initiallySelectedUsers);
      }


      dispatch(initCommonState());
    }
  }, [commonState.commonGetFourthSuccess]);

  const selectUser = (event, userId, user) => {
    const isChecked = event.target.checked;
    setSelectedUsers((prevSelected) => {
      const updatedList = isChecked
        ? [...prevSelected, userId]
        : prevSelected.filter((id) => id !== userId);
      return updatedList;
    });

    setSelectedUsersList((prevSelected) =>
      isChecked
        ? [...prevSelected, user]
        : prevSelected.filter((u) => u.staffId !== user.staffId)
    );
  };

  const SelectAll = (event) => {
    const isChecked = event.target.checked;
    if (isChecked) {
      const allUserIds = employeeList.map((row) => row.staffId);
      setSelectedUsers(allUserIds);
      const allUserList = employeeList.map((row) => row);
      setSelectedUsersList(allUserList);
    } else {
      setSelectedUsers([]);
      setSelectedUsersList([]);
    }
  };

  const searchEmployees = (val, dataList) => {
    setSearchQuery(val);
    const filteredEmployees = dataList.filter(
      (v) =>
        v.full_name.toLowerCase().includes(val.toLowerCase()) ||
        v.employee_id.toLowerCase().includes(val.toLowerCase())
    );
    setEmployeeList(filteredEmployees);
  };

  const handleAssignShiftSubmit = (e) => {
    e.preventDefault();
    const data = {
      path: assignEmployeeDepartmentPath,
      data: {
        userId: user.user_id,
        staffId: selectedUsers.toString(),
        departmentId: departmentId,
      },
    };
    dispatch(commonSaveData(data));
  };



  const handleInputChange = ({ target: { name, value } }) => {
    setState((preState) => ({
      ...preState,
      [name]: value,
    }));
  };

  const preSubmitBsDtl = () => {
    let elem = document.querySelector("#form-save");
    if (elem) {
      elem.click();
    }
  };

  return (
    <div
      className="SettingBody"
      style={{
        position: "fixed",
        width: "calc(100%)",
        height: "100%",
        borderRadius: "7px",
        overflow: "auto",
        backgroundColor: "",
      }}
    >
      <div className="branch-container" style={{ marginTop: "-20px" }}>
        <Widgets
          icon={
            <WidgetsIcon
              icon={
                <Link to="/setting/" className="icon-color">
                  <ArrowBackIcon />
                </Link>
              }
              title="Company Departments"
            />
          }
          button={
            <ButtonCom
              type={"button"}
              class_name={"border-radius-8px universal-btn"}
              text={"Add Departments"}
              url_or_onclick={handleClickOpen}
              icon={<AddIcon style={{position: "relative", top: "-2px"}} />}
              width={""}
            />
          }
          body={
            <>
              <div
                className="ag-theme-quartz custom-grid mt-2"
                style={{
                  height: "calc(100vh - 240px)",
                  width: "100%",
                }}
              >
              <AgGridReact
  rowData={Array.isArray(departmentList) ? departmentList : []}
  columnDefs={heading}
  domLayout="autoHeight"
  pagination={true}
  paginationPageSize={paginationPageSize}
  paginationPageSizeSelector={paginationPageSizeSelector}
  onGridReady={onGridReady}
  // Add these props for consistent row/header sizing
  rowHeight={48}
  headerHeight={48}
  suppressCellFocus={true}
  // Add default column definition
  defaultColDef={{
    resizable: true,
    sortable: false,
    filter: false,
    suppressMenu: true,
  }}
  // Optional: Add these for better grid behavior
  onFirstDataRendered={(params) => {
    params.api.sizeColumnsToFit();
  }}
  onGridSizeChanged={(params) => {
    params.api.sizeColumnsToFit();
  }}
/>
              </div>
              <div className="d-flex align-items-center justify-content-between custom-pagination">
                {gridApi && <CustomPagination gridApi={gridApi} />}
              </div>
            </>
          }
        />
      </div>

      <Dialog
        fullWidth={true}
        maxWidth={"sm"}
        open={open}
        onClose={handleClose}
      >
        <DialogTitle className="dialog-title">
          <div className="dialog-title-icon">
            <span className="close-icon" onClick={handleClose}>
              X
            </span>
            <span className="title">
              {isEdit ? "Update" : "Add New"} Department
            </span>
          </div>
          <button className="universal-btn" onClick={preSubmitBsDtl}>
            {isEdit ? "Update" : "Add"}
          </button>
        </DialogTitle>

        <Form
          noValidate
          validated={validated}
          onSubmit={isEdit ? handleEditSubmit : handleSubmit}
        >
          <DialogContent>
            <Row>
              <Col sm="12">
                <Form.Label className="color-white">Department Name</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter department name"
                  name="departmentName"
                  value={addDepartment.departmentName}
                  onChange={handleChange}
                  required
                  className="universal-input-one"
                />
                <Form.Control.Feedback type="invalid">
                  Please provide a valid department name
                </Form.Control.Feedback>
              </Col>
            </Row>
          </DialogContent>
          <DialogActions>
            <Button
              variant="contained"
              color="info"
              type="submit"
              style={{
                fontWeight: "400",
                fontSize: "16px",
                lineHeight: "10px",
                height: "35px",
                width: "100px",
                display: "none",
              }}
              className="universal-btn"
              id="form-save"
            >
              Save
            </Button>
          </DialogActions>
        </Form>
      </Dialog>

      <Modal show={show} onHide={handleModalClose} backdrop="static">
        <Modal.Header closeButton>
          <Modal.Title>Delete Department</Modal.Title>
        </Modal.Header>
        <Modal.Body>Are you sure! to delete this record?</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleModalClose}>
            Cancel
          </Button>
          <Button variant="danger" onClick={handleDeleteSubmit}>
            Delete
          </Button>
        </Modal.Footer>
      </Modal>

      <AssignEmployee
        isOpen={show1}
        closeOpenDialog={handleModalClose1}
        submitData={handleAssignShiftSubmit}
        isSelectAll={isSelectAll}
        SelectAll={SelectAll}
        selectedUsersList={selectedUsersList}
        employeeList={employeeList}
        selectedUsers={selectedUsers}
        selectUser={selectUser}
        branchList={branchList}
        departmentList={departmentList}
        state={state}
        handleInputChange={handleInputChange}
        getData={""}
        searchQuery={searchQuery}
        searchEmployees={searchEmployees}
        outletName={outletName}
        dataList={filterEmployeeList}
      />

      <ToastContainer
        position="top-right"
        autoClose={2000}
        className="toast-custom"
      />
    </div>
  );
};

export default CompanyDepartments;
